import { validate } from 'validate.js'; // eslint-disable-line import/no-extraneous-dependencies
import {
  validateDateRange,
  validateDateInRange,
  validateDate,
  validateIban
} from './custom-validators';

export const initializeModelUtils = () => {
  validate.validators.validDateRange = (value, required, key, attributes) => {
    if (!value) return required ? `${key} is required` : undefined;

    const start = attributes.start || attributes.start_date;
    const end = attributes.end || attributes.end_date || attributes.expires;
    return validateDateRange(start, end);
  };

  validate.validators.dateInProjectRange = (
    value,
    options,
    key,
    attributes
  ) => {
    const { start, end } = attributes.project;
    return validateDateInRange(value, start, end, 'project');
  };

  validate.validators.validDate = value => {
    validateDate(value);
  };

  validate.validators.validIban = value => {
    return validateIban(value);
  };
};

export default { initializeModelUtils };
